import { toRem } from '@marriott/mi-ui-library';
import styled from 'styled-components';

export const StyledWishlistHeartButton = styled.div`
  .m-heart-pop-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${toRem(32)};
    height: ${toRem(32)};
    overflow: visible;

    .icon {
      bottom: ${toRem(4)};
      right: ${toRem(4)};
      top: unset;
      left: unset;
    }
  }

  .m-heart-pop-button__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transform-origin: center center;
    will-change: transform;
  }
`;
